import React, { Component } from "react";
import Loading from "./Loading";
import PropTypes from "prop-types";
import InputRow from "./InputRow";
import InputRowArabic from "./InputRowArabic";
import { handleAlphabetCheck, arabicValue } from "../constants";

export default class ArabicInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      arabicText1: "",
      arabicText2: "",
      arabicText3: "",
      arabicText4: "",
      arabicText5: "",
    };
    //this.fetchCity = this.fetchCity.bind(this);
  }

  componentDidMount() {
    if (this.props.arabicData.length) {
      this.setState({
        arabicText1:
          this.props.arabicData.length > 0
            ? this.props.arabicData[0].ColumnValue
            : "",
        arabicText2:
          this.props.arabicData.length > 1
            ? this.props.arabicData[1].ColumnValue
            : "",
        arabicText3:
          this.props.arabicData.length > 2
            ? this.props.arabicData[2].ColumnValue
            : "",
        arabicText4:
          this.props.arabicData.length > 3
            ? this.props.arabicData[3].ColumnValue
            : "",
        arabicText5:
          this.props.arabicData.length > 4
            ? this.props.arabicData[4].ColumnValue
            : "",
      });
    }
    this.setState({
      loading: false,
    });
  }

  render() {
    const validationError = this.props.error;
    const {
      loading,
      error,
      arabicText1,
      arabicText2,
      arabicText3,
      arabicText4,
      arabicText5,
    } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div id="height">
        <div>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <p>
            Enter your official information in Arabic as it appears on your ID
            or passport:
          </p>
          <p style={{ color: "black" }}>
            Click next to navigate to the next section
          </p>
          <div>
            <InputRowArabic
              name="text"
              value={arabicText1}
              rowName="الإسم"
              required={this.props.selectedNationality == 1 ? "*" : ""}
              errMsg={
                validationError.arabicText1 ? validationError.arabicText1 : ""
              }
              //required = "*"
              dir="rtl"
              writingDirection="rtl"
              textAlign="rtl"
              secureTextEntry="false"
              placeholder={"عربي"}
              onChange={(val) => {
                const text = arabicValue(val);
                this.setState({ arabicText1: text });
                this.props.collectState("OIA", {
                  arabicText1: text,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  arabicText4: arabicText4,
                  arabicText5: arabicText5,
                });
              }}
            />
            <InputRowArabic
              name="text"
              value={arabicText2}
              rowName="اسم الاب"
              //required = "*"
              required={this.props.selectedNationality == 1 ? "*" : ""}
              dir="rtl"
              writingDirection="rtl"
              textAlign="rtl"
              secureTextEntry="false"
              placeholder={"عربي"}
              errMsg={
                validationError.arabicText2 ? validationError.arabicText2 : ""
              }
              onChange={(val) => {
                const text = arabicValue(val);
                this.setState({ arabicText2: text });
                this.props.collectState("OIA", {
                  arabicText1: arabicText1,
                  arabicText2: text,
                  arabicText3: arabicText3,
                  arabicText4: arabicText4,
                  arabicText5: arabicText5,
                });
              }}
            />
            <InputRowArabic
              name="text"
              value={arabicText3}
              rowName="الشهرة"
              // required = "*"
              required={this.props.selectedNationality == 1 ? "*" : ""}
              dir="rtl"
              writingDirection="rtl"
              textAlign="rtl"
              secureTextEntry="false"
              placeholder={"عربي"}
              errMsg={
                validationError.arabicText3 ? validationError.arabicText3 : ""
              }
              onChange={(val) => {
                const text = arabicValue(val);
                this.setState({ arabicText3: text });
                this.props.collectState("OIA", {
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: text,
                  arabicText4: arabicText4,
                  arabicText5: arabicText5,
                });
              }}
            />
            <InputRowArabic
              name="text"
              value={arabicText4}
              rowName="رقم السجل"
              // required = "*"
              required={this.props.selectedNationality == 1 ? "*" : ""}
              dir="rtl"
              writingDirection="rtl"
              textAlign="rtl"
              secureTextEntry="false"
              placeholder={"عربي"}
              errMsg={
                validationError.arabicText4 ? validationError.arabicText4 : ""
              }
              onChange={(val) => {
                const text = arabicValue(val);
                this.setState({ arabicText4: text });
                this.props.collectState("OIA", {
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  arabicText4: text,
                  arabicText5: arabicText5,
                });
              }}
            />
            <InputRowArabic
              name="text"
              value={arabicText5}
              rowName="المنطقة"
              // required = "*"
              required={this.props.selectedNationality == 1 ? "*" : ""}
              dir="rtl"
              writingDirection="rtl"
              textAlign="rtl"
              secureTextEntry="false"
              placeholder={"عربي"}
              errMsg={
                validationError.arabicText5 ? validationError.arabicText5 : ""
              }
              onChange={(val) => {
                const text = arabicValue(val);
                this.setState({ arabicText5: text });
                this.props.collectState("OIA", {
                  arabicText1: arabicText1,
                  arabicText2: arabicText2,
                  arabicText3: arabicText3,
                  arabicText4: arabicText4,
                  arabicText5: text,
                });
              }}
            />
          </div>
        </div>

        <button
          className="save"
          onClick={() => {
            this.props.onSave();
          }}
        >
          Next
        </button>
      </div>
    );
  }
}

ArabicInformation.propTypes = {
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  arabicData: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
};
